import { ValidatedForm } from '@theme/validated-form';

/**
 * Client-side validation for the "Work with us" contact form.
 *
 * All behavior lives in `ValidatedForm` — this subclass exists only to give the
 * section its own tag name. See `assets/validated-form.js` for the markup hooks.
 */
class WorkWithUsForm extends ValidatedForm {}

if (!customElements.get('work-with-us-form')) {
  customElements.define('work-with-us-form', WorkWithUsForm);
}
